import { View, Text, StyleSheet, TextInput, Dimensions, PixelRatio, Modal, ScrollView, TouchableOpacity, FlatList, ActivityIndicator } from 'react-native'
import React, { useEffect, useState } from 'react'
import Colours from '../utils/Colours'
import TopHeaderComponent from '../screens/aTopHeader/TopHeaderComponent';
import CommentReplysComponent from './CommentReplysComponent';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import Comments from '../icons/Comments';
import { Image } from 'expo-image';

const { width, height } = Dimensions.get('window');
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = 'dxfdmlk0f';
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicCelebThumbnailHeight = Math.round((width / BASE_WIDTH) * 35);
const dynamicCelebThumbnailWidth = Math.round((width / BASE_WIDTH) * 35);

const CommentComponent = ({ selectedCelebratory, tableComments, tableCommentsReplies, tableScreen }) => {
    const [isCommentFocused, setIsCommentFocused] = useState(false)
    const [showCommentsReplys, setShowCommentsReplys] = useState(false)
    const [comments, setComments] = useState([]);
    const [commentCount, setCommentCount] = useState(0);
    const [commentId, setCommentId] = useState('')

    const [tableID, setTableId] = useState('')

    const [isLoadingComm, setIsLoadingComm] = useState(false)

    const [retryCount, setRetryCount] = useState(0);

    const [imageKey, setImageKey] = useState(0);


    const axiosPrivate = useAxiosPrivate()

    useEffect(() => {
        console.log('tableComments', tableComments)
    }, [])


    useEffect(() => {
        const fetchComments = async () => {
            if (!selectedCelebratory) return;

            const createdFor = selectedCelebratory.createdFor._id;
            console.log('createdFor:', createdFor);
            setIsLoadingComm(true)

            try {
                // Adjust endpoint name if your backend route differs
                const response = await axiosPrivate.get(`/mainComment/mainComment/${createdFor}`);

                if (response.data?.success) {
                    // Assuming backend sends full comment array
                    setComments(response.data.comments); // store full comment list
                    setCommentCount(response.data.comments.length); // derive count dynamically
                }
            } catch (err) {
                console.log("Error fetching comments:", err);
            } finally {
                setIsLoadingComm(false)
            }
        };
        fetchComments();

    }, [selectedCelebratory]);


    const handleCommentInput = () => {

    }

    const handleShowReplys = (comment_Id, tableid = null) => {
        if (tableid) {
            setTableId(tableid)
        }
        setCommentId(comment_Id)
        setShowCommentsReplys(true)
    }



    const getOptimizedCloudinaryUrl = (
        originalUrl,
        targetWidth,
        targetHeight
    ) => {
        if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
            return originalUrl;
        }

        // The 'transformations' string includes the optimization flags
        const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

        // Inject the transformations into the URL
        return originalUrl.replace(
            /upload\//,
            `upload/${transformations}/`
        );
    };

    const handleImageError = () => {
        if (retryCount < MAX_RETRIEZ) {
            // Increment the retry counter
            setRetryCount(prevCount => prevCount + 1);

            // Force component re-render by changing the key
            setImageKey(prevKey => prevKey + 1);

            //console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
        } else {
            // Log final failure or set a state to show a permanent fallback icon
            //console.error('Image failed to load after maximum retries.');
        }
    };

    return (
        <View style={styles.commentContainer}>

            {isLoadingComm ? (
                <ActivityIndicator size="large" color={Colours.PRIMARY} />
            ) : (
                <FlatList
                    data={tableScreen ? tableComments : comments}
                    scrollEnabled={false}
                    keyExtractor={(item) => item._id}
                    renderItem={({ item }) => {


                        const imageCommentURL = item.userID.profilePicture

                        const newImageCommentURL = getOptimizedCloudinaryUrl(
                            imageCommentURL,
                            dynamicCelebThumbnailHeight,
                            dynamicCelebThumbnailWidth,
                        );


                        return (
                            <View style={styles.a_comment} >

                                <View>
                                    {/* User profile section */}
                                    <View style={styles.profileContainer}>
                                        <Image
                                            source={
                                                item.userID?.profilePicture
                                                    ? { uri: newImageCommentURL }
                                                    : require('../../assets/profile_image_holder.jpg')
                                            }
                                            key={imageKey}
                                            style={[styles.userImage, { backgroundColor: '#d6d4d4ff' }]}
                                            contentFit="cover"
                                            cachePolicy="disk"
                                            onError={handleImageError}
                                        />
                                        <View>
                                            <Text
                                                style={{
                                                    fontSize: dynamicFontSize(12),
                                                    color: Colours.PRIMARY,
                                                    fontFamily: 'Sen-Regular',
                                                }}
                                            >
                                                {item.userID?.username}
                                            </Text>
                                        </View>
                                    </View>

                                    {/* Comment text */}
                                    <Text
                                        style={{
                                            fontSize: dynamicFontSize(15),
                                            fontFamily: 'Sen-Regular',
                                            color: Colours.DARKGRAY,
                                            textAlign: 'justify',
                                        }}
                                    >
                                        {item.commentText}
                                    </Text>

                                    {/* Reply section */}
                                    <TouchableOpacity
                                        style={styles.hostUserSubContainer}
                                        onPress={() => {
                                            if (tableScreen) {
                                                handleShowReplys(item._id, item.tableID);
                                            } else {
                                                handleShowReplys(item._id);
                                            }
                                        }}
                                    >
                                        {/* <Text
                                        style={{
                                            fontSize: dynamicFontSize(12),
                                            fontFamily: 'Sen-Regular',
                                            color: Colours.PRIMARY,
                                        }}
                                    >
                                        Reply
                                    </Text> */}
                                        <Comments height={dynamicSize(24)} width={dynamicSize(24)} color={Colours.PRIMARY_LIGHT} />
                                        <Text
                                            style={{
                                                fontSize: dynamicFontSize(12),
                                                fontFamily: 'Sen-Regular',
                                                color: Colours.PRIMARY,
                                            }}
                                        >
                                            {item.replyCount == 0 ? '' : item.replyCount}
                                        </Text>
                                    </TouchableOpacity>
                                </View></View>
                        )
                    }}
                />
            )}


            <Modal
                animationType='slide'
                visible={showCommentsReplys}
                onRequestClose={() => setShowCommentsReplys(false)}
            >
                <TopHeaderComponent headerText={"Replys"} hideScreen={() => setShowCommentsReplys(false)} />
                <ScrollView
                    // ref={scrollViewRef}
                    contentContainerStyle={{ flexGrow: 1, paddingBottom: 100, backgroundColor: Colours.LIGHTEST }}>
                    <View style={{ backgroundColor: Colours.LIGHTEST }}>
                        <CommentReplysComponent
                            commentId={commentId}
                            selectedCelebratory={selectedCelebratory}
                            tableCommentsReplies={tableCommentsReplies}
                            tableID={tableID}
                        // userData={userData}
                        />
                    </View>
                </ScrollView>
            </Modal>

        </View>
    )
}

const styles = StyleSheet.create({
    commentContainer: {
        display: 'flex',
        // backgroundColor: 'white',
        padding: dynamicSpacing(10),
        borderRadius: dynamicSize(15),
    },
    textDescInputStyle: {
        height: dynamicSize(100),
        marginBottom: dynamicSpacing(10),
        // gap: 10,
        padding: dynamicSpacing(15),
        borderWidth: dynamicSize(3),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(15),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(17),
        verticalAlign: 'top',
        backgroundColor: Colours.LIGHTGRAY,
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: dynamicSpacing(15),
        paddingBottom: dynamicSpacing(6),
        gap: dynamicSpacing(10),
    },
    a_comment: {
        display: 'flex',
        backgroundColor: 'white',
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(10),
        marginTop: dynamicSpacing(15),

    },
    userImage: {
        width: dynamicSize(35),
        height: dynamicSize(35),
        borderRadius: dynamicSize(99),
    },
    hostUserSubContainer: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: dynamicSpacing(5)
    },

})


export default CommentComponent